export enum Affect {
    NORMAL =  'Normal',
    BLUNTED =  'Blunted',
    FLAT =  'Flat',
    INAPPROPRIATE =  'Inappropriate',
    LABILE =  'Labile',
    RESTRICTED =  'Restricted',
}